export enum FeatureEnum {
    DASHBOARD = 'dashboard',
    PROFILE = 'profile',
    TRACKING_TAB = 'tracking_tab',
    DRINK_TRACKING_DUAL_MODE = 'drink_tracking_dual_mode',
    DRINK_TRACKING_REST_API_ONLY = 'drink_tracking_rest_api_only',
    SUNNYSIDE_PREVIEW = 'sunnyside_preview',
    TRACKING_TAB_V2 = 'tracking_tab_v2',
    TARGETS_RESTAPI = 'targets_restapi',
    COACH_NOTE = 'coach_note',
    COMMUNITY_IOS = 'community_ios',
    CONFIGURABLE_NOTIFICATIONS_BASE = 'configurable_notifications_base',
    WEEKLY_PLANNING = 'weekly_planning',
    EARLY_CONFIRM_FLIP_TEST = 'early_confirm_flip_test',
    AFTERNOON_REMINDER = 'afternoon_reminder',
    CONFIGURABLE_NOTIFICATIONS_UI = 'configurable_notifications_ui',
    IN_APP_CHALLENGE = 'in_app_challenge',
    SUNNY_RESPONDS = 'sunny_responds',
    SUNNY_RESPONDS_EXTENDED = 'sunny_responds_extended',
    COMMUNITY_SETTINGS_INTERNAL = 'community_settings_internal',
    RASA_REPLACEMENT = 'rasa_replacement',
    GPT_INSIGHTS = 'gpt_insights',
    NEW_CHALLENGE_FLAVOURS = 'new_challenge_flavours',
    PROGRESS_V2 = 'progress_v2',
    PROGRESS_V2_ALPHA = 'progress_v2_alpha',
    TRACKING_TRENDS = 'tracking_trends',
    APPLE_HEALTH_CONNECT = 'apple_health_connect',
    APPLE_HEALTH_LOGS = 'apple_health_logs',
    LAMBDA_PLAN_GENERATION = 'lambda_plan_generation',
    NUX_2025Q1 = 'nux_2025q1',
    NUX_MORNING_CONFIRMATION_TEST = 'nux_morning_confirmation_test',
    NUX_MORNING_CONFIRMATION_CONTROL = 'nux_morning_confirmation_control',
    MAT_INTERNAL = 'mat_internal',
    CHURNKEY_INTERNAL = 'churnkey_internal',
    MF_CONFLICT_RESOLUTION_INTERNAL = 'mf_conflict_resolution_internal',
    MED_SYNC_VISIT_INTERNAL = 'med_sync_visit_internal',
    FORCE_NUX_ONBOARDING_FOR_MED = 'force_nux_onboarding_for_med',
    MF_CONFLICT_RESOLUTION_INTERNAL_V2 = 'mf_conflict_resolution_internal_v2',
    CARE_COACHING = 'care_coaching',
    TODAY_SCREEN = 'today_screen'
}
